import React from 'react';
import MirroringStream from '../MirroringStream';
import './Multiview.css';

interface GridLayout {
  columns: number;
  rows: number;
}

interface StreamData {
  sessionId: string;
  isInitiator: boolean;
  name: string;
}

interface MultiviewProps {
  streams: StreamData[];
  gridLayout: number;
}

const Multiview: React.FC<MultiviewProps> = ({ streams, gridLayout }) => {
  // Calcola le colonne/righe in base al numero selezionato
  let gridTemplateColumns = '';
  let gridTemplateRows = '';

  // Esempio di layout:
  switch (gridLayout) {
    case 1:
      gridTemplateColumns = '1fr';
      gridTemplateRows = 'calc(100% - 150px) calc(100% - 150px)';
      break;
    case 2:
      gridTemplateColumns = '1fr 1fr';
      gridTemplateRows = '1fr';
      break;
    case 4:
      gridTemplateColumns = 'repeat(2, 1fr)'
      gridTemplateRows = 'calc(50% - 100px) calc(50% - 100px)';
      break;
    case 8:
      gridTemplateColumns = 'repeat(4, 1fr)';
      gridTemplateRows = 'repeat(2, 1fr)';
      break;
    case 12:
    default:
      gridTemplateColumns = 'repeat(4, 1fr)';
      gridTemplateRows = 'repeat(3, 1fr)';
      break;
  }

  return (
    <div
      className="mirroring-grid"
      style={{ gridTemplateColumns: gridTemplateColumns, gridTemplateRows: gridTemplateRows }}
    >
      {streams.map((stream, index) => (
        <div key={index} className="grid-item">
          {/* Mostra il nome del device */}
          <div className="device-name">
            {stream.name}
          </div>
          <div className="video-wrapper">
          <MirroringStream sessionId={stream.sessionId} isInitiator={stream.isInitiator} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Multiview;
